import React from 'react';
import J1Section from '../section/J1Section';
import PageTransition from '../components/PageTransition';

const J1Page = () => {
  return (
    <PageTransition>
      <J1Section />
    </PageTransition>
  );
};

export default J1Page;
